import {buildInfo} from './buildInfo';

export const getBuildInfo = () => ({...buildInfo, release: buildInfo.release.substr(0, 7)});
